<div class="pex-dialog-close">
    <button
        type="button"
        class="circle-close-button"
        (click)="this.close()"
        [attr.aria-label]="'CLOSE' | translate"
    >
        <svg class="circle-close-button-icon">
            <use xlink:href="icons.svg#x" />
        </svg>
    </button>
</div>

<form
    (ngSubmit)="addParticipant()"
    #addParticipantForm="ngForm"
    class="pex-dialog-content-inner"
    autocomplete="off"
>
    <div class="pex-dialog-content-title">
        {{ 'ADD_PARTICIPANT_DIALOG.TITLE' | translate }}
    </div>

    <div class="pex-dialog-content-message">
        <div class="error-text" *ngIf="this.config?.previousURI">
            {{ 'ADD_PARTICIPANT_DIALOG.FAILED' | translate }}
        </div>
        <div class="participant-wrapper">
            <div class="participant-input">
                <input
                    id="dialog-add-participant-input"
                    type="text"
                    class="pex-text-input participant-text inputs"
                    [attr.aria-label]="
                        'ADD_PARTICIPANT_DIALOG.PLACEHOLDER' | translate
                    "
                    [placeholder]="
                        'ADD_PARTICIPANT_DIALOG.PLACEHOLDER' | translate
                    "
                    name="uri"
                    [class.grey]="this.config?.previousURI"
                    [formControl]="participantFormControl"
                    #participantURI
                    required=""
                />
                <!-- <div
                    class="participant-autocomplete"
                    *ngIf="directoryResults.length > 0"
                    #participantAutocomplete
                >
                    <div
                        (keyup.enter)="divEntryBtn.click()"
                        (keyup.space)="divEntryBtn.click()"
                        role="button"
                        tabindex="0"
                        class="participant-autocomplete-item"
                        [attr.aria-label]="entry.alias"
                        (click)="
                            participantURI.value = entry.alias;
                            directoryResults = []
                        "
                        *ngFor="let entry of directoryResults"
                        #divEntryBtn
                    >
                        <p class="participant-autocomplete-item__line">
                            {{ entry.alias }}
                        </p>
                        <p class="participant-autocomplete-item__line">
                            {{ entry.description }}
                        </p>
                    </div>
                </div> -->
            </div>
            <div
                class="participant-role"
                (click)="contextMenu.open(participantRole)"
                #participantRole
            >
                <span *ngIf="!isHost">{{ 'GUEST' | translate }}</span>
                <span *ngIf="isHost">{{ 'HOST' | translate }}</span>

                <svg class="participant-role__icon">
                    <use xlink:href="icons.svg#chevron-down" />
                </svg>
            </div>
            <ng-template pexContextMenu #contextMenu="pexContextMenu">
                <pex-context-menu-item
                    (keyup.enter)="isHost = false"
                    (keyup.space)="isHost = false"
                    (click)="isHost = false"
                    role="button"
                    tabindex="0"
                    [icon]="
                        'icons.svg' + (!isHost ? '#check-square' : '#square')
                    "
                    [attr.aria-label]="'GUEST' | translate"
                    [label]="'GUEST' | translate"
                    #guestContextMenuBtn
                ></pex-context-menu-item>
                <pex-context-menu-item
                    (keyup.enter)="isHost = true"
                    (keyup.space)="isHost = true"
                    (click)="isHost = true"
                    role="button"
                    tabindex="0"
                    [icon]="
                        'icons.svg' + (isHost ? '#check-square' : '#square')
                    "
                    [attr.aria-label]="'HOST' | translate"
                    [label]="'HOST' | translate"
                    #hostContextMenuBtn
                ></pex-context-menu-item>
            </ng-template>
        </div>
    </div>
    <div class="pex-dialog-content-button">
        <button
            type="submit"
            class="dialog-button buttons green-action-button"
            id="conference-add-participant-btn"
            [class.gray-action-button]="!participantFormControl.valid"
            [disabled]="!participantFormControl.valid"
        >
            {{ 'ADD_PARTICIPANT_DIALOG.BUTTON' | translate }}
        </button>
    </div>
</form>
